// Selectors for DOM elements
const wishlistSelectors = {
  button: ".swym-heart",
  grid: "[grid-wishlist]",
  productCard: ".wishlist-card .product-card",
  wishlistCountBubble: ".swym-wish-counter",
  resetButton: "[button-wishlist-reset]",
  dynamicGrid: "[dynamic-grid]",
};

// Updates the wishlist count bubble in the UI
function updateWishlistCountBubble() {
  const wishlistCountBubble = document.querySelectorAll(
    wishlistSelectors.wishlistCountBubble
  );
  wishlistCountBubble.forEach((element) => {
    if (window._swat.renderWishlistCount) {
      window._swat.renderWishlistCount(element, function (cnt, elem) {});
    }
  });
}

function swymCallbackFn(swat) {
  updateWishlistCountBubble();

  function swymAttachEvents() {
    swat.initializeActionButtons(wishlistSelectors.dynamicGrid);
    swat.initializeActionButtons("body");
  }

  document.addEventListener("quickview:loaded", function (e) {
    console.log("Quickview Loaded!");
    swymAttachEvents();
  });

  document.addEventListener("swym:collections-loaded", function () {
    console.log("swym:collections-loaded");
    swymAttachEvents();
  });

  // Add listener for the 'addedtowishlist' event to the Swym Event Layer
  swat.evtLayer.addEventListener("sw:addedtowishlist", function (e) {
    const data = e.detail.d;
    console.log("sw:addedtowishlist");
    // update button state here...
    const wishlistButtons = document.querySelectorAll(
      `.swym-heart[data-product-id="${data.empi}"]`
    );
    if (wishlistButtons.length > 0) {
      wishlistButtons.forEach((button) => {
        button.classList.add("disabled", "swym-added", "swym-adding");
        button.classList.remove("swym-removing");
      });
    }
  });

  // Add listener for the 'removedfromwishlist' event to the Swym Event Layer
  swat.evtLayer.addEventListener("sw:removedfromwishlist", function (e) {
    const data = e.detail.d;
    console.log("sw:removedfromwishlist");
    // update button state here...
    const wishlistButtons = document.querySelectorAll(
      `.swym-heart[data-product-id="${data.empi}"]`
    );
    if (wishlistButtons.length > 0) {
      wishlistButtons.forEach((button) => {
        button.classList.add("swym-removing");
        button.classList.remove("disabled", "swym-added", "swym-adding");
      });
    }
  });
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);
